import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';
import { QueueManagementStrategyOption } from '../models/queue-management-option';

export const queueManagementStrategyOptionActions = createEagerSelectActions<QueueManagementStrategyOption>(
   '[Queue Management Strategy Options]'
);
